import SearchBar from '@/vuetify_custom/v-form'
import AutocompletesAsyncV1 from '@/vuetify_custom/v-form/components/Autocompletes_Async_v1.js'
import VTable from '@/vuetify_custom/v-table/v3'
import VPage from '@/vuetify_custom/v-pagination'
import UserFlowBase from '@/views/components/flow/user_flow_base_jsx_v1'
import PageContain from '@/views/components/PageContain.vue'
import EditModal from './EditThridModal'
import ExpendComponent from './ExpendComponent'
import { thrid_fields, status_thrid } from './fields'
import styles from './index.module.less'
import { VAutocomplete, VBtn } from 'vuetify/lib'
import util from '@/libs/util.js'
import { getThirdPartyShopQueryListApi, changeStatusShopApi } from './services'
import { THRID } from './constants'
export const { 
  third_party_shop_export
} = util.api || {}
export default {
    data() {
        return {
           // show_all_fields: true,
            records: [],
            expend_hash: {},
            apply_customer_hash: {},
            llllist:[],
            getDataLoading: false,
            selectedId: null,
            params: {
                company_id: '',
                payee_company_id:'',
                team_id:'',
                status:'',
                key_value:'',
                page:1,
                per_page:20,
                total_count: 0,
              },
            
        }
    },
    computed: {
      is_financer() {
        const cur_customer = this.$store.state.cur_customer
        return cur_customer.groups && cur_customer.groups.includes('GROUP_FIN');
      },
      cur_customer() {
        return this.$store.state.cur_customer;
      },
        status_thrid_hash() {
            return status_thrid.reduce((t, i) => {
                t[i.key] = i
                return t
            }, {})
        },
        search_fields() {
            const proxyGetData = this.proxyGetData
              const arr = [
                  {
                      label: '开店公司主体',
                      type: 'company_select',
                      key: 'company_id',
                      cols: 2,
                      clearable:true,
                      change: proxyGetData,
                      show: true
                  },
                  {
                    label: '收入公司主体',
                    key: 'payee_company_id',
                    clearable:true,
                    // type:'autocompletes_async_v1',
                    has_placeholder: false,
                    out_params: {
                      page:1,
                      per_page:20,
                    },
                    search_key: 'payee_company_name',
                    'item-value':'id',
                    'item-text':'name',
                    api: this.$util.api.payee_company_query_list,
                    cols: 2,
                    handle_data:({payee_companies}) => {
                      
                        return payee_companies
                     //  this.apply_user_list = customers
                    },
                   change: proxyGetData,
                   show: true
                  },
                  {
                    label: '团队',
                    type: 'team_select',
                    key: 'team_id',
                    cols: 2,
                    clearable:true,
                    change: proxyGetData,
                    show: true
                  },
                  {
                    label: '店铺状态',
                    type: 'select_field_v1',
                    key: 'status',
                    cols: 2,
                    clearable:true,
                    items:status_thrid,
                    change: proxyGetData,
                    show: true
                  },
                  {
                    key: 'key_value',
                    cols: 4,
                    clearable:true,
                    'append-icon':'mdi-magnify',
                    placeholder: '请输入搜索内容',
                    'click:append': proxyGetData,
                    'keydown.enter':proxyGetData,
                    'click:clear': proxyGetData,
                    show: true,
                  },
                  {
                    key: 'handle',
                    cols: 1,
                    show: this.is_financer
                  }
                //   {
                //     key: 'action',
                //     cols: 2,
                    
                //   }
              ]
             //   arr = this.show_all_fields ? arr : arr.slice(-1)
              return arr.filter(i => i.show).map(i => {
                if (i.key === 'key_value' && this.is_financer) {
                  return {
                    ...i,
                    cols: 3
                  }
                }
                return i
              })
          },
        table_fields() {
            return [
                {
                    expand:true,
                    z_index:2,
                },
                ...thrid_fields,
                {
                    text: '状态',
                    align: 'center',
                    value: '_status',
                    width: 100,
                     fixed: 'right',
                    z_index:1,
                    render: (val, target) => {
                        const item = this.status_thrid_hash[target.status] || {}
                        return <div style={{color:item.color }}>{item.title}</div>
                    }
                },
                {
                    text: '操作',
                    align: 'center',
                    value: 'handle',
                    b_text: '操作',
                    type: 'button_s_field',
                    width: 96,
                    z_index:1,
                     fixed: 'right',
                    callBack:({key}, target) => {
                        let status = target.status
                      switch (key) {
                          case 'edit':
                            this.$refs['modal'].show(target)
                              break;
                          case 'change_status':
                              this.$vModal.confirm({
                                  title: '提示',
                                  content: '测试',
                                  loading: true,
                                  render:(h) => {
                                    return h('div', {}, [h(VAutocomplete, {
                                      props: {
                                        value: status,
                                        label: '店铺状态',
                                        items:status_thrid,
                                        'item-text': 'title',
                                        'item-value': 'key'
                                      },
                                      on: {
                                        change:(val) => {
                                            status = val
                                        }
                                      }
                                    })])
                                  },
                                  onOk:({destroy, stopLoading}) => {
                                    changeStatusShopApi({
                                        id: target.id,
                                        status,
                                    }).then(() => {
                                        destroy()
                                        this.$Message.success('状态修改成功！')
                                        this.getList({page:1}) 
                                    }).finally(() => {
                                        stopLoading()
                                    })
                                  }
                              })
                              break
                          default:
                              break;
                      }
                    },
                    buttons:() => {
                      return [
                        {
                            text: '编辑',
                            key: 'edit',
                            show: true
                        },
                        {
                            text: '修改状态',
                            key: 'change_status',
                            show: true
                        },
                    ].filter(i => i.show)
                    }
                }
            ]
        },
    },
    mounted() {
      this.getList()
    },
    methods: {
      proxyGetData() {
          this.params.page = 1
          this.$nextTick(() => {
              this.getList()
          })
      },
      getList(params = {}) {
        this.getDataLoading = true
         params = {...this.params, ...params}
         params = JSON.parse(JSON.stringify(params))
         Object.keys(params).forEach(key => {
             if (params[key] === '') {
                delete params[key]
             }
         })
        getThirdPartyShopQueryListApi(params).then(({
            list,
            page,
          per_page,
          total_count,
        }) => {
          this.params.page = page
          this.params.per_page = per_page
          this.params.total_count = total_count
          this.records = list
        
        }).finally(() => {
          this.getDataLoading = false
        })
      }
    },
    render() {
        const _this = this
        return <div>
            <div class={styles['search-module']}>
                <SearchBar
                    v-model={this.params}
                    fields={_this.search_fields}
                    scopedSlots={{
                      payee_company_id:({field, value}) => {
                        return <AutocompletesAsyncV1 field={field} v-model={value}/>
                      },
                      handle: () => {
                        return <div >
                          <VBtn style="margin-top:15px" color="primary" small on={{
                            click: () => {
                              window.open(`/api/third_party_shop/export`, '__blank')
                            }
                          }}> 导出 </VBtn>
                        </div>
                      }
                     
                      /*  action :() => {
                            return <div class={styles['contain-p']}>
                                <VBtn 
                                    // content-p
                                    class={styles['content-p']}
                                    color="primary"
                                    on={{
                                        click: () => {
                                            this.show_all_fields = !this.show_all_fields
                                        }
                                    }}
                                    icon>
                                    <VIcon 
                                       
                                    > {this.show_all_fields ? 'mdi-arrow-collapse-horizontal' : 'mdi-arrow-expand-horizontal' }</VIcon>
                                </VBtn>
                                   
                                </div>
                        }*/
                    }}
                />
            </div>
            <PageContain reserved-height={252}>
            
              <VTable
                    headers = {_this.table_fields}
                    desserts = {_this.records}
                    loading={_this.getDataLoading}
                    fixedHeader
                    fixedHeaderZindex={3}
                    scopedSlots = {{
                        expand: ({ item }) => {
                            // if (!_this.expend_hash[item.opening_shop_order_id]) {
                            //     _this.selectedId = item.opening_shop_order_id
                            //     _this.expend_hash[item.opening_shop_order_id] = item
                            //     // getApplyOpenShopDetailApi({id:item.opening_shop_order_id }).then(res => {
                            //     //     _this.expend_hash[item.opening_shop_order_id] = res
                            //     // }).finally(() => {
                            //     //     _this.selectedId = null
                            //     // })
                            // }
                            // loading={item.opening_shop_order_id === _this.selectedId}
                        return <ExpendComponent
                                
                                item={item}
                                target={item}
                                entryType={THRID}
                            />
                        },
                        status: (_, item) => {
                            
                            return <div >
                            {item && !!item.user_flow && <UserFlowBase 
                                modelC={item}
                                user_flow={item.user_flow || {}}
                                show_handles={true}
                            />}
                            {(!item || !item.user_flow)}
                            </div>
                        },
                        fill_customer_id:(_) => {
                            return _this.fill_customer_hash && _this.fill_customer_hash[_] && _this.fill_customer_hash[_].account
                        }
                    }}
                /> 
            </PageContain>
           <EditModal
               ref="modal"
               on={{
                 success:(res) => {
                  // 数据更新了，删除之前的缓存数据
                  delete _this.expend_hash[res && res.id]
                  setTimeout(() => {
                    _this.getList({
                      cur_page: 1
                     })
                  }, 500)
                 }
               }}
              />
             <div class={styles['paginate-fix-bottom']}>
              {!!this.params.total_count && <VPage
                current={this.params.page}
                total={this.params.total_count}
                page-size={this.params.per_page}
                size-arr={[10, 20, 50]}
                on={
                  {
                    changePageSize:(per_page) => {
                      this.getList({
                        page:1,
                        per_page
                      })
                    },
                    pageChange:(page) => {
                      this.getList({
                        page
                      })
                    }
                  }
                }
              />}
            </div>
        </div>
    }
}